import { isAxiosError } from 'axios';

const SEND_ERROR_MESSAGE = 'Не удалось отправить сообщение';

export const getSendErrorMessage = (error: unknown) =>
  (isAxiosError<{ message?: string }>(error) &&
    error.response?.data?.message) ||
  SEND_ERROR_MESSAGE;
